import $ from 'jquery';

window.copyLink = function(el) {
    var input = $(el).parents('.uk-modal-body').find('input')[0];
    input.select();
    document.execCommand("copy");
}